module.exports = __webpack_public_path__ + "img/electronic_electric_reserved_selected.21b77c3e.svg";